import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { ActionType } from "./actions.js";
import { addMemoAction, changeMemoColorAction, changeMemoValueAction, moveMemoAction, moveToMemoAction, removeMemoAction, resizeMemoAction } from "./atom.actions.js";
import { groupBy, head, last, pick } from "es-toolkit";
//#region src/engine/modules/memo/history.ts
var MOVE_MIN = 20;
var addMemo = (undoActions, { payload: { id } }) => {
	undoActions.push(removeMemoAction({ id }));
};
var removeMemo = (undoActions, { payload: { id } }, { collections }) => {
	const memo = query(collections).collection("memoEntities").selectById(id);
	if (!memo) return;
	undoActions.push(addMemoAction({
		id: memo.id,
		ui: pick(memo.ui, [
			"x",
			"y",
			"zIndex"
		])
	}));
};
var changeMemoValue = (undoActions, { payload: { id } }, { collections }) => {
	const memo = query(collections).collection("memoEntities").selectById(id);
	if (!memo) return;
	undoActions.push(changeMemoValueAction({
		id,
		value: memo.value
	}));
};
var moveToMemo = (undoActions, { payload: { id } }, { collections }) => {
	const memo = query(collections).collection("memoEntities").selectById(id);
	if (!memo) return;
	undoActions.push(moveToMemoAction({
		id,
		x: memo.ui.x,
		y: memo.ui.y
	}));
};
var memoPushUndoHistoryMap = {
	[ActionType.addMemo]: addMemo,
	[ActionType.removeMemo]: removeMemo,
	[ActionType.changeMemoValue]: changeMemoValue,
	[ActionType.moveToMemo]: moveToMemo
};
var moveMemo = (undoActions, redoActions, actions) => {
	const moveMemoActions = actions.filter((action) => action.type === moveMemoAction.type);
	if (!moveMemoActions.length) return;
	const group = groupBy(moveMemoActions, (action) => action.payload.ids.join(","));
	for (const [, actions] of Object.entries(group)) {
		const { payload: { ids } } = head(actions);
		const { x, y } = actions.reduce((acc, { payload: { movementX, movementY } }) => {
			acc.x += movementX;
			acc.y += movementY;
			return acc;
		}, {
			x: 0,
			y: 0
		});
		if (Math.abs(x) + Math.abs(y) < MOVE_MIN) continue;
		undoActions.push(moveMemoAction({
			ids,
			movementX: -1 * x,
			movementY: -1 * y
		}));
		redoActions.push(moveMemoAction({
			ids,
			movementX: x,
			movementY: y
		}));
	}
};
var changeMemoColor = (undoActions, redoActions, actions) => {
	const changeMemoColorActions = actions.filter(({ type }) => type === changeMemoColorAction.type);
	if (!changeMemoColorActions.length) return;
	const group = groupBy(changeMemoColorActions, (action) => action.payload.id);
	for (const [id, actions] of Object.entries(group)) {
		const firstAction = head(actions);
		const lastAction = last(actions);
		undoActions.push(changeMemoColorAction({
			id,
			color: firstAction.payload.prevColor,
			prevColor: lastAction.payload.color
		}));
		redoActions.push(changeMemoColorAction({
			id,
			color: lastAction.payload.color,
			prevColor: firstAction.payload.prevColor
		}));
	}
};
var resizeMemo = (undoActions, redoActions, actions) => {
	const resizeMemoActions = actions.filter((action) => action.type === resizeMemoAction.type);
	if (!resizeMemoActions.length) return;
	const group = groupBy(resizeMemoActions, (action) => action.payload.id);
	for (const [, actions] of Object.entries(group)) {
		if (actions.length < 2) continue;
		const firstAction = head(actions);
		const lastAction = last(actions);
		undoActions.push(firstAction);
		redoActions.push(lastAction);
	}
};
var memoPushStreamHistoryMap = {
	[ActionType.moveMemo]: moveMemo,
	[ActionType.changeMemoColor]: changeMemoColor,
	[ActionType.resizeMemo]: resizeMemo
};
//#endregion
export { memoPushStreamHistoryMap, memoPushUndoHistoryMap };
